<template>
<div class="page-content-warehouse__body--setting">
	<div class="row">
		<div class="col-12 col-md-6">
			<div class="setting">
				<div>
					<span class="font-weight-bold">
						{{ $t('Setting Warehouse')  }}
					</span>
				</div>
				<span>
					{{ $t('Warehouse management to be displayed to buyers based on the shortest distance or cheapest postage automatically.') }}
				</span>
			</div>
		</div>
		<div class="col-12 col-md-6">
			<checkbox-toggle :label="isEnabled ? $t('Aktif') : $t('Non Aktif')" :value="isEnabled" @input="setToogle" />
		</div>
	</div>
</div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import CheckboxToggle from '@/components/CheckboxToggle.vue';

export default {
	name: 'SettingWarehouseSectionBodySetting',
	components: {
		CheckboxToggle,
	},
	props: {
		enabled: {
			type: Boolean,
			default: () => false,
		},
	},
	data() {
		return {
			toogleSetting: false,
		};
	},
	computed: {
		...mapGetters({
			configuration: 'warehouse/configuration',
		}),
		isEnabled: {
			get() {
				return this.enabled;
			},
			set(value) {
				this.enabled = value;
			},
		},
	},
	methods: {
		...mapActions({
			settingUserConfiguration: 'warehouse/settingUserConfiguration',
			fetchSettingUserConfiguration: 'warehouse/fetchSettingUserConfiguration',
		}),
		setToogle(value) {
			this.$emit('set', value);
			// const params = [
			// 	{
			// 		key: 'warehouse',
			// 		value: {
			// 			enabled: value,
			// 			shipping_type: this.configuration.shipping_type,
			// 		},
			// 	},
			// ];
			// this.settingUserConfiguration(JSON.stringify(params));
		},
	},
};
</script>

<style></style>
